module.exports = __webpack_public_path__ + "static/img/culture4.789fa493.png";